module.exports = __webpack_public_path__ + "static/media/Safe.4a2bbad1.png";